import { sendEvent } from './honeycomb'

const stationInComputer = (computer, stationId) => {
  const station = computer.printer_stations.edges.find(
    station => station.node.row_id === stationId,
  )

  return station && station.node
}

const printerForStation = (computer, stationId, type) => {
  const station = stationInComputer(computer, stationId)
  const printer = computer.printers.edges.find(
    printer => printer.node.row_id === station[`${type}_printer`],
  )

  return printer && printer.node
}

export const scaleForStation = (computer, stationId) => {
  console.log()
  const station = stationInComputer(computer, stationId)
  if (!station) {
    return [null, null]
  }
  const scale = computer.usb_devices.edges.find(
    usb => usb.node.row_id === station.scale,
  )

  return [station, scale && scale.node]
}

export const onNewPrintJob = (computer, payload, ipc) => {
  console.log('Received print request', computer, payload)
  payload.files.map(file => {
    const printer = printerForStation(computer, payload.station_id, file.type)
    ipc.send('print-file', { file, printer })

    let metadata = {}
    try {
      if (payload.metadata) {
        metadata = JSON.parse(payload.metadata)
      }
    } catch (e) {
      console.log('Could not parse metadata', e)
    }

    const client_timestamp = Date.now();
    const appsync_timestamp = payload.created_at
    const appendpoints_timestamp = metadata.timestamp || null

    const eventBody = {
      event_type: `event_${file.type}`,
      name: 'print',
      account_id: computer.account_id,
      order_id: metadata.orderId,
      client_timestamp,
      appsync_timestamp,
      appendpoints_timestamp,
    }

    sendEvent(ipc, eventBody)
  })
}
